import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import * as Sentry from '@sentry/react';

// styles
import './styles/reset.css';

// utils and configs
import {AVL_ENVIRONMENT} from "./config/vars";

// pages and components
import { AuthWrapper, AuthenticatedRoute } from './components/auth';
import { Page404 } from './pages/404';
import { LoginPage, LogoutPage } from './pages/auth';
import { DataPage } from './pages/data';
import { OrgsPage } from './pages/data/orgs';
import { LocsPage } from './pages/data/locs';
import { DevsPage } from './pages/data/devs';
import { RecsPage } from './pages/data/recs';
import { AccessPage } from './pages/data/access';
import { ComponentsPage } from './pages/data/components';

// config sentry if necessary
import { USE_SENTRY } from './config/vars';
if (USE_SENTRY) {
    Sentry.init({
        dsn:
            'https://5337268db9fe477989daf78500f5707b@o135941.ingest.sentry.io/5338025'
    });
}

console.log(`Running on ${AVL_ENVIRONMENT}`)

const App = () => (
    <AuthWrapper>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/orgs" replace />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/logout" element={<LogoutPage />} />
                <Route element={<AuthenticatedRoute login="/login" />}>
                    <Route element={<DataPage />}>
                        <Route path="/orgs/*" element={<OrgsPage />} />
                        <Route path="/locs/*" element={<LocsPage />} />
                        <Route path="/devs/*" element={<DevsPage />} />
                        <Route path="/recs/*" element={<RecsPage />} />
                        <Route path="/access/*" element={<AccessPage />} />
                        <Route path="/components" element={<ComponentsPage />} />
                    </Route>
                </Route>
                <Route path="*" element={<Page404 />} />
            </Routes>
        </BrowserRouter>
    </AuthWrapper>
)

createRoot(document.getElementById('root')).render(<App />);
